// Status text mapping for reservation/ticket/order states
const STATUS_TEXT_MAP = {
  예약: "CONFIRMED",
  결제완료: "PAID",
  부분취소: "부분취소",
  사용안함: "사용가능",
  입장: "입장",
  퇴장: "퇴장",
  외출: "외출",
  완료: "완료",
  사용함: "사용완료",
  만료됨: "기간만료",
  배송준비중: "배송준비",
  배송중: "배송중",
  배송완료: "배송완료",
  주문접수: "PAID",
  취소요청: "취소요청",
  취소완료: "취소완료",
  노쇼: "노쇼",
};

// Status color categories
export const STATUS_CATEGORIES = {
  success: ["CONFIRMED", "예약", "입장", "외출", "퇴장", "사용안함", "받기가능", "사용가능", "결제완료"],
  warning: ["PAID", "부분취소", "배송준비중", "배송중", "주문접수", "배송준비"],
  muted: ["완료", "사용함", "배송완료", "다운완료", "사용완료"],
  danger: ["노쇼", "만료됨", "취소요청", "취소완료", "기간만료"],
};

/**
 * Get display text for a status
 * @param {string} state - The raw state from API
 * @returns {string} Human-readable status text
 */
export const getStatusText = (state) => {
  return STATUS_TEXT_MAP[state] || state;
};

/**
 * Get color for a status
 * @param {string} status - The status value
 * @returns {string} Hex color code
 */
export const getStatusColor = (status) => {
  if (STATUS_CATEGORIES.success.includes(status)) return "#22c55e";
  if (STATUS_CATEGORIES.warning.includes(status)) return "#eab308";
  if (STATUS_CATEGORIES.muted.includes(status)) return "#888";
  if (STATUS_CATEGORIES.danger.includes(status)) return "#ef4444";
  return "#888";
};

/**
 * Get status category name
 * @param {string} status - The status value
 * @returns {'success' | 'warning' | 'muted' | 'danger'} Category name
 */
export const getStatusCategory = (status) => {
  if (STATUS_CATEGORIES.success.includes(status)) return "success";
  if (STATUS_CATEGORIES.warning.includes(status)) return "warning";
  if (STATUS_CATEGORIES.muted.includes(status)) return "muted";
  if (STATUS_CATEGORIES.danger.includes(status)) return "danger";
  return "muted";
};

/**
 * Check if an item is usable (not completed/expired/cancelled)
 * @param {string} state - The state value
 * @returns {boolean}
 */
export const isUsableState = (state) => {
  return STATUS_CATEGORIES.success.includes(state) || STATUS_CATEGORIES.warning.includes(state);
};

/**
 * Check if an item is completed/used
 * @param {string} state - The state value
 * @returns {boolean}
 */
export const isCompletedState = (state) => {
  return STATUS_CATEGORIES.muted.includes(state) || STATUS_CATEGORIES.danger.includes(state);
};
